import { Node } from '@tiptap/core'
import { Plugin } from 'prosemirror-state'
import { v4 } from 'uuid'

const types: { [key: string]: boolean } = {
  heading: true,
}

export const BlockId = Node.create({
  name: 'blockId',

  addGlobalAttributes() {
    return [
      {
        types: Object.keys(types),
        attributes: {
          blockId: {
            default: null,
            rendered: false,
            keepOnSplit: false,
          },
        },
      },
    ]
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        appendTransaction: (_transactions, oldState, newState) => {
          // New state = old state, no change.
          if (newState.doc === oldState.doc) {
            return
          }

          const transaction = newState.tr

          newState.doc.descendants((node, pos, parent) => {
            if (
              node.isBlock &&
              parent === newState.doc &&
              !node.attrs.blockId &&
              types[node.type.name]
            ) {
              transaction.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                blockId: v4(),
              })
            }
          })

          return transaction
        },
      }),
    ]
  },
})
